$(document).ready(function () {

  // hide translated pages
  if ((window.lang == 'it')) {
    $('.locale-en').hide();
    $('.colore_en').hide();
    $('.locale-it').show();
    $('.colore_it').show();
  } else {
    $('.locale-en').show();
    $('.colore_en').show();
    $('.colore_it').hide();
    $('.locale-it').hide();
  }

  // collection page -- filter modal
  $('#filter-btn').on('click', function () {
    $('.filter-container').toggleClass('filter-hide');
    // hide sort if is open
    $('.sort-container').addClass('sort-hide');
    $('#sort-btn').removeClass('rotate');
  });
  $('.close-btn').on('click', function () {
    $(this).parent().addClass('filter-hide');
  });
  // collection page -- sort modal

  $('#sort-btn').on('click', function () {
    $(this).toggleClass('rotate');
    $('.sort-container').toggleClass('sort-hide');
    // hide filter if is open
    $('.filter-container').addClass('filter-hide');
  });
  $('.close-btn-sort').on('click', function () {
    $('#sort-btn').removeClass('rotate');
    $(this).parent().addClass('sort-hide');
  });
  $('#sort-btn-mobile').on('click', function () {
    $('details.disclosure-has-popup').addClass('menu-opening').attr('open', '');
    $('#Details-Mobile-sort').addClass('menu-opening').attr('open', '');
    $('body').addClass('overflow-hidden-mobile');
  })


  // Menu
  const link = $(".link-title");
  link.on('click', function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().removeClass('open');
      // $('body').removeClass('no-scroll');
    } else {
      if (link.parent().hasClass('open')) {
        link.parent().removeClass('open');
        $(this).parent().addClass('open');
      } else {
        $(this).parent().addClass('open');
        // $('body').addClass('no-scroll');
      }
    }
  })
  // click outside
  // $(document).mouseup(function (e) {
  //   console.log('asdasd')
  //   if(!container.is(e.target) &&
  //     container.has(e.target).length === 0) {
  //     container.parent().removeClass('open');
  //     $('body').removeClass('no-scroll');
  //   }
  // });

  //
  // $('.show_hide').show();
  // $('.size-btn').click(function (e) {
  //   $('body').addClass('no-scroll')
  //   var id = e.currentTarget.id;
  //   $('.modal-size-box').show();
  //
  //   $('.size-modal').animate({
  //       scrollTop: $('#div' + id).offset().top
  //     },
  //     'slow');
  //
  // });
  //

  // product page check gender for tabs active
  $('.product-popup-modal__button').on('click', function () {
    if ($('#gender').val()=='m') {
      console.log('ok man')
      $('.tab-m').addClass('active')
      $('.tab-w').removeClass('active')
    }else{
      $('.tab-w').addClass('active')
      $('.tab-m').removeClass('active')
    }
    //go to product id
    let key = $('.product-popup-modal').attr('key');
    let ret = key.split(/[-,./\s]/);
    let str1 = ret[0];
    $('#' + str1).parent().addClass('show')
    console.log('MOD:',str1);
    // if(str1 == 'edda'){
    //   let newStr = ret[0]+ret[1];
    //   $('#' + newStr).parent().addClass('show')
    // }

    //  if(str1 == 'andres'){
    //   let newKey = ret[0]+ret[1];
    //   $('#' + newKey).parent().addClass('show')
    // }
  });
  // $('.product-popup-modal__toggle').on('click', function () {
  //   $('.tab').removeClass('active')
  // });
  $('.tab').on('click', function () {
    if (!$(this).hasClass('active')) {
      $('.tab').removeClass('active')
      $(this).addClass('active')
      let myClass = $(this).attr("class");
      if (~myClass.indexOf('tab-w')) {
        $('.tab-container').removeClass('active')
        $('.tab-container.tab-w').addClass('active')
      }
      if (~myClass.indexOf('tab-m')) {
        $('.tab-container').removeClass('active')
        $('.tab-container.tab-m').addClass('active')
      }
    }
  })
// cms page
  var $container = $("#ord-list-custom");
  if ($container.length > 0) {
    var offset = $(".main-container").offset();
    if ($(window).width() > 767) {
      $container.stick_in_parent({
        parent: $(".page-with-sidebar"),
        offset_top: offset
      });
    }
    var $link = $("a", $container);
    $link.click(function () {
      $link.removeClass("active");
      $(this).addClass("active");
    });
    if (window.location.hash) {
      $link.removeClass("active");
      $('a[href="' + window.location.hash + '"]').addClass('active');
    }
  }        
})